
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectdossierDocumentselectionEntryDto } from '../models/work-projectdossier-documentselection-entry-dto';

export function getUpdateProjectdossierDocumentselectionDtoFormGroup() {
return new FormGroup({
    documentselection: new FormControl<WorkProjectdossierDocumentselectionEntryDto[]>([]),
})
;
}
      